import config from '../config'

declare global {
  interface Window {
    __cannyInitialized?: boolean
    Canny: CannyFunction
    attachEvent?: (event: string, listener: () => void) => void
  }
}

interface CannyFunction {
  (command: string, options?: Record<string, unknown>): void
  q: IArguments[]
}

export default function initialize(): void {
  // Prevent double initialization
  if (window.__cannyInitialized) return
  window.__cannyInitialized = true

  // Clear stale data before Canny writes again
  try {
    localStorage.removeItem('canny-changelog-screen')
  } catch (e) {
    console.warn('Could not clear Canny localStorage:', e)
  }

  // load script
  ;(function (w: Window, d: Document, i: string, s: string) {
    function l(): void {
      if (!d.getElementById(i)) {
        const f = d.getElementsByTagName(s)[0]
        const e = d.createElement(s) as HTMLScriptElement
        e.type = 'text/javascript'
        e.async = true
        e.src = 'https://canny.io/sdk.js'
        if (f.parentNode) {
          f.parentNode.insertBefore(e, f)
        }
      }
    }
    if (typeof w.Canny !== 'function') {
      const c = function () {
        c.q.push(arguments)
      } as unknown as CannyFunction
      c.q = []
      w.Canny = c
      if (d.readyState === 'complete') {
        l()
      } else if (w.attachEvent) {
        w.attachEvent('onload', l)
      } else {
        w.addEventListener('load', l, false)
      }
    }
  })(window, document, 'canny-jssdk', 'script')

  // identify canny user for tracking
  window.Canny('identify', {
    appID: '5d5d8089f6d07e70de8637a3',
    user: {
      email: config.user.email || `user-${config.user.id}@cannydedupebyid.com`,
      name: config.user.name,
      id: config.user.id,
      customFields: {
        role: config.user.role,
      },
      companies: [
        {
          id: config.user.organization.id,
          name: config.user.organization.name,
        },
      ],
    },
  })

  // load the change log with notification bell
  window.Canny('initChangelog', {
    appID: '5d5d8089f6d07e70de8637a3',
    position: 'bottom',
    align: 'right',
  })
}